const enableIfExists = (className) => {
  if (document.querySelector(`.${className}`)) {
    document.querySelector(`.${className}`).style.display = "";
  }
};

const enableLoopExists = (tagName) => {
  if (document.getElementsByTagName(tagName).length > 0) {
    document
      .getElementsByTagName(tagName)
      .forEach((iframe) => (iframe.style.display = ""));
  }
};

const disableIfExists = (className) => {
  if (document.querySelector(`.${className}`)) {
    document.querySelector(`.${className}`).style.display = "none";
  }
};

const disableLoopExists = (tagName) => {
  if (document.getElementsByTagName(tagName).length > 0) {
    const data = document.getElementsByTagName(tagName);
    const dataList = Array.prototype.slice.call(data);
    return dataList
      .forEach((iframe) => (iframe.style.display = "none"));
  }
};

export const disableInteraction = () => {
  document.body.style.pointerEvents = "none";
  document.body.style.cursor = "not-allowed";
  document.body.style.overflow = "hidden";
  disableIfExists("download_asset_big");
  disableIfExists("content_bar");
  disableIfExists('course_content');
  disableLoopExists("iframe");
};

export const goHome = () => {
  document.body.style.pointerEvents = "visible";
  document.body.style.cursor = "auto";
  document.body.style.overflow = "visible";
  enableIfExists("download_asset_big");
  enableIfExists("content_bar");
  enableIfExists("course_content");
  enableLoopExists("iframe");

  window.location.href = "/#/home";
};



// WEBPACK FOOTER //
// ./src/components/Modal/ModalFunctions.jsx